import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'

export const getStore = createAsyncThunk('get/store', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/store/${process.env.REACT_APP_STORE_ID}`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getCategoriesTree = createAsyncThunk('get/categories/tree', async (_: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v1/categories/tree?parent_id=${process.env.REACT_APP_CATEGORY_ID}`)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})

export const getCategories = createAsyncThunk('get/categories', async (body: any, { dispatch, rejectWithValue }) => {
  try {
    const categoriesTreeResult = await dispatch(getCategoriesTree(body)).unwrap()
    const { data } = await axiosInstance.get(`/v1/categories/${process.env.REACT_APP_CATEGORY_ID}/children`)

    const mergedData = data.data.map((category: any) => {
      const matchingCategory = categoriesTreeResult.find((treeCategory: any) => treeCategory.id === category.id)

      if (matchingCategory) {
        return {
          ...category,
          children: matchingCategory.childrens,
        }
      }

      return category
    })

    return mergedData
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
